// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_aq-0";
export var orangeButton = "_aq-1";